import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { useNavigate } from 'react-router-dom'
import { colors, radius, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const DEFAULT_THINKER = `TEMEL KONUŞMA AKIŞI:

ADIM 1 — KATEGORİ SEÇİMİ:
Müşteri genel bir ürün söylediğinde DB'den eşleşen kategorileri bul ve butonlarla seçtir.
Tek kategori eşleşiyorsa direkt ADIM 2'ye geç.
Seçilen kategori en alt kategoriyse tekrar alt kategori sorma.

ADIM 2 — AKILLI SORULAR:
Kategori belirlendikten sonra ürünü nerede ve nasıl kullanacağını sor.
Ürün tipine göre 1-2 soru sor (mekan büyüklüğü, kapasite, kullanım amacı vb.)

ADIM 3 — BÜTÇE:
"Bütçeniz nedir?" diye sor.

ADIM 4 — ÜRÜN ARA:
Tüm bilgiler toplandığında type:search döndür.
categoryCode: seçilen kategori kodunu yaz.
features: müşterinin söylediği özellikler listesi.

---
MARKA ÖZEL KURALLAR (buraya ekle):
`

const style = {
  card: { ...s.card, padding: '24px' },
  input: { ...s.input, width: 'auto', padding: '9px 12px' },
}

function SmartBot() {
  const { selectedBrand, setSelectedBrand } = useBrand()
  const navigate = useNavigate()
  const [stats, setStats] = useState(null)
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [startDate, setStartDate] = useState(() => {
    const d = new Date()
    d.setDate(d.getDate() - 30)
    return d.toISOString().split('T')[0]
  })
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0])
  const [toggling, setToggling] = useState(false)
  const [thinker, setThinker] = useState('')
  const [thinkerSaved, setThinkerSaved] = useState(false)
  const [thinkerSaving, setThinkerSaving] = useState(false)
  const [activeTab, setActiveTab] = useState('stats')

  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  useEffect(() => {
    if (!selectedBrand) return
    fetchStats()
    fetchLogs()
    fetchThinker()
  }, [selectedBrand]) // eslint-disable-line

  function fetchStats() {
    setLoading(true)
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smartbot/stats?start_date=${startDate}&end_date=${endDate}`, { headers })
      .then(res => { setStats(res.data); setLoading(false) })
      .catch(() => setLoading(false))
  }

  function fetchLogs() {
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smartbot/logs?start_date=${startDate}&end_date=${endDate}&limit=20`, { headers })
      .then(res => setLogs(res.data.logs || []))
      .catch(() => {})
  }

  function fetchThinker() {
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smartbot/thinker`, { headers })
      .then(res => setThinker(res.data.thinker || ''))
      .catch(() => setThinker(''))
  }

  async function saveThinker() {
    setThinkerSaving(true)
    try {
      await axios.post(`${API}/admin/brands/${selectedBrand.id}/smartbot/thinker`, { thinker }, { headers })
      setThinkerSaved(true)
      setTimeout(() => setThinkerSaved(false), 2500)
    } catch (e) { }
    setThinkerSaving(false)
  }

  function resetThinker() {
    if (window.confirm('Thinker varsayılan ayarlara sıfırlanacak. Emin misiniz?')) {
      setThinker(DEFAULT_THINKER)
    }
  }

  async function handleToggle() {
    setToggling(true)
    try {
      const res = await axios.patch(`${API}/admin/brands/${selectedBrand.id}/smartbot-toggle`, {}, { headers })
      setSelectedBrand({ ...selectedBrand, smartbot_enabled: res.data.smartbot_enabled })
    } catch (e) { }
    setToggling(false)
  }

  function handleFilter() {
    fetchStats()
    fetchLogs()
  }

  if (!selectedBrand) return (
    <div style={{ textAlign: 'center', padding: '60px' }}>
      <p style={{ ...ui.emptyText, marginBottom: '16px' }}>Önce bir marka seçin.</p>
      <button onClick={() => navigate('/brands')} style={s.btnPrimary}>Markalara Git</button>
    </div>
  )

  return (
    <div>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginBottom: '24px' }}>
        <h2 style={s.pageTitle}>Smart Bot — {selectedBrand.name}</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', color: colors.textSecondary }}>Smart Bot:</span>
          <button
            onClick={handleToggle}
            disabled={toggling}
            style={{
              ...ui.btnSm,
              padding: '9px 18px',
              fontSize: '13px',
              fontWeight: '600',
              color: selectedBrand.smartbot_enabled ? colors.textPrimary : colors.textMuted
            }}
          >
            <span style={ui.statusDot(selectedBrand.smartbot_enabled)} />
            {toggling ? '...' : selectedBrand.smartbot_enabled ? 'Aktif' : 'Pasif'}
          </button>
        </div>
      </div>

      {/* Tab menü */}
      <div style={ui.tabBar}>
        {[
          { key: 'stats', label: 'İstatistikler' },
          { key: 'thinker', label: 'Thinker' }
        ].map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={ui.tab(activeTab === tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Thinker tab */}
      {activeTab === 'thinker' && (
        <div style={style.card}>
          <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap', marginBottom: '12px' }}>
            <div style={{ minWidth: 0, flex: '1 1 260px' }}>
              <h3 style={s.sectionTitle}>Bot Davranış Kuralları (Thinker)</h3>
              <p style={s.sectionSubtitle}>
                Bu alan botun nasıl davranacağını belirler. Temel akışı düzenleyebilir, marka özel kurallar ekleyebilirsiniz.
              </p>
            </div>
            <div className="sx-wrap" style={{ display: 'flex', gap: '8px', flexShrink: 0, flexWrap: 'wrap', marginLeft: '16px', maxWidth: 'calc(100% - 16px)' }}>
              <button onClick={resetThinker} style={s.btnSecondary}>
                Varsayılana Sıfırla
              </button>
              <button onClick={saveThinker} disabled={thinkerSaving} style={{ ...s.btnPrimary, padding: '9px 20px' }}>
                {thinkerSaving ? 'Kaydediliyor...' : thinkerSaved ? '✓ Kaydedildi' : 'Kaydet'}
              </button>
            </div>
          </div>

          <div style={{ ...s.alertWarning, marginBottom: '16px' }}>
            Temel akışı değiştirirken dikkatli olun. Yanlış bir değişiklik botun çalışmamasına neden olabilir.
          </div>

          <textarea
            value={thinker}
            onChange={e => setThinker(e.target.value)}
            className="sx-tall"
            style={{
              width: '100%',
              minHeight: '400px',
              padding: '16px',
              borderRadius: radius.md,
              border: `1px solid ${colors.border}`,
              fontSize: '13px',
              color: colors.textPrimary,
              background: colors.bgCard,
              outline: 'none',
              lineHeight: '1.6',
              fontFamily: 'monospace',
              boxSizing: 'border-box',
              resize: 'vertical'
            }}
          />
        </div>
      )}

      {/* İstatistikler tab */}
      {activeTab === 'stats' && (
        <>
          <div style={{ ...style.card }}>
            <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
              <div>
                <label style={s.label}>Başlangıç</label>
                <input type="date" style={style.input} value={startDate} onChange={e => setStartDate(e.target.value)} />
              </div>
              <div>
                <label style={s.label}>Bitiş</label>
                <input type="date" style={style.input} value={endDate} onChange={e => setEndDate(e.target.value)} />
              </div>
              <button onClick={handleFilter} style={{ ...s.btnPrimary, padding: '9px 20px' }}>Filtrele</button>
              <button onClick={() => { const d = new Date(); setStartDate(d.toISOString().split('T')[0]); setEndDate(d.toISOString().split('T')[0]) }} style={{ ...ui.btnSm, padding: '8px 14px' }}>Bugün</button>
              <button onClick={() => { const d = new Date(); d.setDate(d.getDate() - 7); setStartDate(d.toISOString().split('T')[0]); setEndDate(new Date().toISOString().split('T')[0]) }} style={{ ...ui.btnSm, padding: '8px 14px' }}>Son 7 Gün</button>
              <button onClick={() => { const d = new Date(); d.setDate(d.getDate() - 30); setStartDate(d.toISOString().split('T')[0]); setEndDate(new Date().toISOString().split('T')[0]) }} style={{ ...ui.btnSm, padding: '8px 14px' }}>Son 30 Gün</button>
            </div>
          </div>

          {loading ? <p style={ui.emptyText}>Yükleniyor...</p> : stats && (
            <>
              <div className="sx-grid-stat" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '16px' }}>
                {[
                  { label: 'Toplam Sohbet', value: stats.total_sessions },
                  { label: 'Toplam Mesaj', value: stats.total_messages },
                  { label: 'Mesaj/Sohbet', value: stats.total_sessions > 0 ? (stats.total_messages / stats.total_sessions).toFixed(1) : 0 }
                ].map((m, i) => (
                  <div key={i} style={ui.statBox}>
                    <div style={{ ...ui.statValue, margin: 0 }}>{m.value}</div>
                    <div style={{ ...ui.statLabel, marginTop: '6px' }}>{m.label}</div>
                  </div>
                ))}
              </div>

              <div className="sx-grid-panel" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: '16px', marginBottom: '16px' }}>
                <div style={style.card}>
                  <h3 style={{ ...s.sectionTitle, margin: '0 0 16px' }}>En Çok Gösterilen Ürünler</h3>
                  {stats.top_products.length === 0 ? <p style={ui.emptyText}>Henüz veri yok.</p> : (
                    <div className="sx-scroll-x">
                      <table style={s.table}>
                        <thead><tr><th style={{ ...s.th, padding: '8px 10px' }}>Ürün</th><th style={{ ...s.th, padding: '8px 10px', textAlign: 'right' }}>Gösterim</th></tr></thead>
                        <tbody>
                          {stats.top_products.map((p, i) => (
                            <tr key={i}>
                              <td style={{ ...s.td, padding: '10px' }}><a href={p.url} target="_blank" rel="noreferrer" style={{ color: colors.primary, textDecoration: 'none' }}>{p.name}</a></td>
                              <td style={{ ...s.td, ...ui.num, padding: '10px', textAlign: 'right' }}>{p.count}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                <div style={style.card}>
                  <h3 style={{ ...s.sectionTitle, margin: '0 0 16px' }}>En Çok Sorulan Aramalar</h3>
                  {stats.top_searches.length === 0 ? <p style={ui.emptyText}>Henüz veri yok.</p> : (
                    <div className="sx-scroll-x">
                      <table style={s.table}>
                        <thead><tr><th style={{ ...s.th, padding: '8px 10px' }}>Arama</th><th style={{ ...s.th, padding: '8px 10px', textAlign: 'right' }}>Sayı</th></tr></thead>
                        <tbody>
                          {stats.top_searches.map((q, i) => (
                            <tr key={i}>
                              <td style={{ ...s.td, padding: '10px' }}>{q.search_query}</td>
                              <td style={{ ...s.td, ...ui.num, padding: '10px', textAlign: 'right' }}>{q.count}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>

              {stats.daily_stats.length > 0 && (
                <div style={style.card}>
                  <h3 style={{ ...s.sectionTitle, margin: '0 0 16px' }}>Günlük Sohbet İstatistikleri</h3>
                  <div className="sx-scroll-x">
                    <table style={s.table}>
                      <thead><tr><th style={{ ...s.th, padding: '10px' }}>Tarih</th><th style={{ ...s.th, padding: '10px', textAlign: 'right' }}>Sohbet</th><th style={{ ...s.th, padding: '10px', textAlign: 'right' }}>Mesaj</th></tr></thead>
                      <tbody>
                        {stats.daily_stats.map((d, i) => (
                          <tr key={i}>
                            <td style={{ ...s.td, padding: '10px' }}>{new Date(d.date).toLocaleDateString('tr-TR')}</td>
                            <td style={{ ...s.td, ...ui.num, padding: '10px', textAlign: 'right' }}>{d.sessions}</td>
                            <td style={{ ...s.td, ...ui.numMuted, padding: '10px', textAlign: 'right' }}>{d.messages}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div style={style.card}>
                <h3 style={{ ...s.sectionTitle, margin: '0 0 16px' }}>Son Konuşmalar</h3>
                {logs.length === 0 ? <p style={ui.emptyText}>Henüz konuşma yok.</p> : (
                  <div className="sx-scroll-x">
                    <table style={s.table}>
                      <thead><tr><th style={{ ...s.th, padding: '10px' }}>Tarih</th><th style={{ ...s.th, padding: '10px' }}>Kullanıcı Mesajı</th><th style={{ ...s.th, padding: '10px' }}>Bot Yanıtı</th><th style={{ ...s.th, padding: '10px' }}>Arama</th></tr></thead>
                      <tbody>
                        {logs.map((l, i) => (
                          <tr key={i}>
                            <td style={{ ...s.td, ...ui.numMuted, padding: '10px', whiteSpace: 'nowrap' }}>{new Date(l.created_at).toLocaleString('tr-TR')}</td>
                            <td style={{ ...s.td, padding: '10px', maxWidth: '200px' }}><div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.user_message}</div></td>
                            <td style={{ ...s.td, padding: '10px', maxWidth: '300px' }}><div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: colors.textSecondary }}>{l.bot_reply}</div></td>
                            <td style={{ ...s.td, padding: '10px' }}>{l.search_query && <span style={ui.chip}>{l.search_query}</span>}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default SmartBot